import { useQuickJournalSharedState } from "./useQuickJournalSharedState";
import { useQuickJournalAnimationEffects } from "./useQuickJournalAnimationEffects";
import { useQuickJournalSyncEffects } from "./useQuickJournalSyncEffects";

export function useQuickJournalDataController() {
    const {
        state,
        setState,
        shouldWipeQuickJournalData,
        useAnopenscrollFont,
    } = useQuickJournalSharedState();

    useQuickJournalSyncEffects({
        state,
        setState,
        shouldWipeQuickJournalData,
    });

    const { shouldFadeInHistoricalRows } = useQuickJournalAnimationEffects({
        state,
        setState,
    });

    return {
        state,
        setState,
        useAnopenscrollFont,
        shouldFadeInHistoricalRows,
    };
}
